import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import { useTracking } from "react-tracking";
import { useTranslation } from "react-i18next";
import { cleanSearchingConfigurationsPaginated, configurationClean } from "../../app/actions/configurationActions";
import DisplayNameAndRole from "./DisplayNameAndRole";

const NavbarIconsConfiguration = ({ page }) => {
  const dispatch = useDispatch();
  const { trackEvent } = useTracking();
  const { t } = useTranslation();

    const { isUserAuthenticated } = useSelector((state) => state.auth);

  const [activeIcon, setActiveIcon] = useState(null);

  const handleActiveIcon = (icon) => {
    
    if (icon === "new") {
      
      trackEvent({ component: "NewConfiguration", event: "NewConfiguration-Clicked" });
    } else if (icon === "list") {
      
      trackEvent({ component: "ListConfiguration", event: "ListConfiguration-Clicked" });
      dispatch(cleanSearchingConfigurationsPaginated());
    }

    dispatch(configurationClean());
    setActiveIcon(icon);
  };

  const iconActiveStyle = (icon) => {
    if (activeIcon === icon) {
      return "icon-d-flex active";
    } else {
      return "icon-d-flex";
    }
  };

  return (
    <div className="d-flex justify-content-between align-items-center flex-nowrap gradient-custom-sky custom-nav-height">
      {isUserAuthenticated && (
        <DisplayNameAndRole />
      )}
      {page === "listConfiguration" && (
        <Link
          data-tip
          data-for="newConfigurationTip"
          to="/admin-configuration/new-configuration"
          className="p-2 bd-highlight"
          onClick={() => handleActiveIcon("new")}
        >
          <i className={`fa fa-plus-square fa-2x ${iconActiveStyle("new")}`} aria-hidden="true" />
        </Link>
      )}
      {page === "newConfiguration" && (
        <Link
          data-tip
          data-for="listConfigurationTip"
          to="/admin-configuration/"
          className="p-2 bd-highlight"
          onClick={() => handleActiveIcon("list")}
        >
          <i className={`fa fa-table fa-2x ${iconActiveStyle("list")}`} aria-hidden="true" />
        </Link>
      )}
      {page === "editConfiguration" && (
        <div className="navbar-module-actions">
          <Link
            data-tip
            data-for="listConfigurationTip"
            to="/admin-configuration/"
            className="p-2 bd-highlight"
            onClick={() => handleActiveIcon("list")}
          >
            <i className={`fa fa-table fa-2x ${iconActiveStyle("list")}`} aria-hidden="true" />
          </Link>
          <Link
            data-tip
            data-for="newConfigurationTip"
            to="/admin-configuration/new-configuration"
            className="p-2 bd-highlight"
            onClick={() => handleActiveIcon("new")}
          >
            <i className={`fa fa-plus-square fa-2x ${iconActiveStyle("new")}`} aria-hidden="true" />
          </Link>
        </div>
      )}

      <ReactTooltip id="newConfigurationTip" place="left" effect="solid">
        {t("admin-configuration.page.register")}
      </ReactTooltip>
      <ReactTooltip id="listConfigurationTip" place="left" effect="solid">
        {t("admin-configuration.page.list")}
      </ReactTooltip>
    </div>
  );
};

export default NavbarIconsConfiguration;
